import React from "react";
import { RCCButton, RCCHookToast, RCCServicesApi, RCCTooltip } from "react-common-components";
import CheckPermission from "src/components/CheckPermission";
import EditableTitle from "src/components/EditableTitle";
import SortableHandle from "src/components/Sortable/Handle";
import { useAuth } from "src/context/Auth/context";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import { ICatbb002 } from "src/pages/BusinessDiagnostics/Canvas/interface";
import PostItContainer from "./styles";

interface IPostIt{
  value: ICatbb002;
	placeholder?: boolean;
	deletePostIt?: (id: string) => void;
	callbackUpdatePostIt?: (id: number, description: string) => void;
}


const PostIt: React.FC<IPostIt> = ({
	value,
	placeholder = false,
	deletePostIt,
	callbackUpdatePostIt
}) => {

	const { addToast } = RCCHookToast();
	const { translate } = useTranslation();
	const { checkIfHasSpecificPermission } = useAuth();

	const permisionToCreateUpdate = checkIfHasSpecificPermission("/canvas", PermissionEnum.CREATE_UPDATE);

	return (
		<>
			<PostItContainer 
				background={value.cab002Cor}
			>
				<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
					{!placeholder && (
						<div className="options-postIt-canvas">
							<RCCTooltip 
								text={translate("Mover Post-it")}
								position="leftEnd"
							>
								<SortableHandle>
						
									<RCCButton
										className="btn-option"
										icon={{
											name: "arrows", 
											color: "#FFF", 
											size: 12
										}}
										layout="isRounded"
										size="xs"
									/>
						
								</SortableHandle>
							</RCCTooltip>	
							<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE_DELETE}>
								<RCCTooltip 
									text={translate("Excluir Post-it")}
									position="leftEnd"
								>
									<RCCButton
										className="btn-option"
										onClick={() => { if(deletePostIt) deletePostIt(value.id); }}
										icon={{
											name: "trash", 
											color: "#FFF", 
											size: 12
										}}
										layout="isRounded"
										size="xs"
									/>
								</RCCTooltip>										
							</CheckPermission>
						</div>	
					)}												
				</CheckPermission>
				
				<EditableTitle 
					value={value.cab002Descricao?.trim() ?? null}
					placeholder={ placeholder ? "" : translate("Descrição do Post-It")}
					onSubmit={async (valueInputPostIt) => {
						await RCCServicesApi.putRequest({
							method: "Canvas/UpdatePostIt",
							body: {
								id: value.cab002Id,
								description: valueInputPostIt
							}
						});

						if(callbackUpdatePostIt)
							callbackUpdatePostIt(value.cab002Id, valueInputPostIt);
						
						addToast({
							color: "green",
							description: translate("Post-it alterado com sucesso"),
							title: translate("Sucesso")
						});
					}}
					maxLength={400}
					pencilIcon={false}
					titleProps={{
						size: "sm",
						color: "black",
						styleInline: "padding: 4px 6px; font-size: 0.8rem; "
					}}
					disabled={!permisionToCreateUpdate}
				/>
			</PostItContainer>
		</>
	);

};

export default PostIt;
